import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=6e0f667b&scoped=true"
import script from "./Tournament.vue?vue&type=script&lang=ts"
export * from "./Tournament.vue?vue&type=script&lang=ts"
import style0 from "./Tournament.vue?vue&type=style&index=0&id=6e0f667b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f667b",
  null
  
)

export default component.exports